import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table } from "antd";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import SearchBox from "../../../components/SearchBox";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getPropertyByKey } from "../../../utils/getPropertyByKey";
import { companyID } from "../../../auth";
import api from "../../../api/axios";
import toast from "react-hot-toast";
import * as XLSX from "xlsx";

const AssetDetails = ({
  setShowCompanyAssets,
  setIsAddModalOpen,
  setAssetDetails,
  setAssetModel,
  isAddModalOpen,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [assetId, setAssetId] = useState(null);
  const [assetModalLoading, setAssetModalLoading] = useState(true);
  const [assetData, setAssetData] = useState({});
  const [assetStatus, setAssetStatus] = useState([]);
  const [assetType, setAssetType] = useState([]);
  const [companyAssets, setCompanyAssets] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selectedAssetTypeFilter, setSelectedAssetTypeFilter] = useState("");

  const employeeId = localStorage.getItem("employeeID");
  const company_id = companyID();

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    fetchAssetStatus();
    fetchAssetType();
  }, [isAddModalOpen]);

  const fetchAssetStatus = () => {
    api
      .get(`assets-status`)
      .then((res) => {
        setAssetStatus(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchAssetType = () => {
    api
      .get(`asset-types`)
      .then((res) => {
        setAssetType(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchCompanyAssets = () => {
    api
      .get(`company-assets/${company_id}`)
      .then((res) => {
        setCompanyAssets(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (company_id) {
      fetchCompanyAssets();
    }
  }, [isAddModalOpen]);

  const editAssetDetail = (record) => {
    setAssetModel({
      title: "Edit",
      buttonText: "Update",
    });
    setIsAddModalOpen(true);
    const {
      purchase_date,
      model,
      serial_number,
      asset_type,
      manufacturer,
      warranty,
      id,
      original_price,
      current_price,
    } = record;
    setAssetDetails({
      selectedDate: purchase_date,
      selectedAssetType: asset_type,
      serialNumber: serial_number,
      modelNumber: model,
      manufacturer: manufacturer,
      warranty: warranty,
      original_price: original_price,
      current_price: current_price,
      editAssetId: id,
    });
  };

  const handleDeleteClick = (id) => {
    setAssetId(id);
    setShowModal(true);
  };

  const deleteAsset = () => {
    setLoading(true);
    api
      .delete(`company-assets/${assetId}`)
      .then((res) => {
        setLoading(false);
        setShowModal(false);
        toast.dismiss();
        toast.success("Asset deleted successfully");
        fetchCompanyAssets();
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      setShowModal(false);
      toast.dismiss();
      toast.error(err?.response?.data?.message || "Failed to delete asset");
      });
  };
  // Filter assets based on selected asset type
  const filteredAssets = selectedAssetTypeFilter
    ? companyAssets.filter((asset) => asset.asset_type === parseInt(selectedAssetTypeFilter))
    : companyAssets;

  const totalPages = Math.max(1, Math.ceil(filteredAssets.length / pageSize));
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const pagedAssets = filteredAssets.slice(startIndex, endIndex);

  const getVisiblePages = () => {
    if (totalPages <= 3) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    let start = Math.max(1, currentPage - 1);
    let end = start + 2;

    if (end > totalPages) {
      end = totalPages;
      start = end - 2;
    }

    return Array.from({ length: end - start + 1 }, (_, index) => start + index);
  };

  const handleAssetTypeFilterChange = (e) => {
    setSelectedAssetTypeFilter(e.target.value);
    setCurrentPage(1); // Reset to first page when filter changes
  };

  useEffect(() => {
    setCurrentPage((prevPage) => Math.min(prevPage, totalPages));
  }, [totalPages]);

  const exportToExcel = () => {
    if (filteredAssets.length === 0) {
      toast.error("No data to export");
      return;
    }

    const exportData = filteredAssets.map((asset) => ({
      "Asset Type": getPropertyByKey(assetType, "id", asset.asset_type, "name"),
      "Serial Number": asset.serial_number || "-",
      "Model": asset.model || "-",
      "Manufacturer": asset.manufacturer || "-",
      "Purchase Price (₹)": asset.original_price || "-",
      "Current Price (₹)": asset.current_price || "-",
      "Purchase Date": asset.purchase_date ? asset.purchase_date.split("T")[0] : "-",
      "Warranty (months)": asset.warranty || "-",
      "Assigned To":
        asset.assignee_name || asset.assignee_official_email
          ? `${asset.assignee_name || "-"} (${asset.assignee_official_email || "-"})`
          : "-",
      "Available": String(Boolean(asset.avaiable ?? asset.available)),
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Company Assets");
    
    const fileName = `Company_Assets_${new Date().toISOString().split('T')[0]}.xlsx`;
    XLSX.writeFile(workbook, fileName);
    
    toast.success("Excel file exported successfully!");
  };

  const mutedTextStyle = {
    color: "#6c757d",
    fontSize: "12px",
  };

  const primaryTextStyle = {
    color: "#111827",
    fontWeight: 600,
    fontSize: "13px",
  };

  const paginationButtonStyle = {
    minWidth: "36px",
    height: "36px",
    borderRadius: "4px",
    border: "1px solid #d9d9d9",
    backgroundColor: "#f5f6f7",
    color: "#6b7280",
    padding: "0 10px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: 1,
  };

  const paginationActiveStyle = {
    ...paginationButtonStyle,
    backgroundColor: "var(--company-theme)",
    borderColor: "var(--company-theme)",
    color: "#ffffff",
  };

  const paginationDisabledStyle = {
    opacity: 0.6,
    cursor: "not-allowed",
  };

  const badgeBaseStyle = {
    display: "inline-block",
    minWidth: "64px",
    padding: "3px 8px",
    borderRadius: "999px",
    fontSize: "11px",
    fontWeight: 600,
    textAlign: "center",
    letterSpacing: "0.2px",
  };

  const formatPrice = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return value;
    return `Rs. ${numericValue.toLocaleString("en-IN")}`;
  };

  const formatWarranty = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return String(value);
    return `${numericValue}m`;
  };

  const formatDate = (value) => {
    if (!value) return "-";
    return value.split("T")[0];
  };

  const columns = [
    {
      title: "Asset",
      key: "asset_summary",
      width: 230,
      render: (_, record) => (
        <div style={{ lineHeight: "1.3" }}>
          <div>
            <span style={primaryTextStyle}>
              {getPropertyByKey(assetType, "id", record.asset_type, "name") || "-"}
            </span>
          </div>
          <div style={{ ...mutedTextStyle, marginTop: "2px" }}>
            SN: {record.serial_number || "-"}
          </div>
        </div>
      ),
    },
    {
      title: (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id="tooltip-specs-header">
              Specs = Model and Manufacturer. Hover row to view full values.
            </Tooltip>
          }
        >
          <span>Specs</span>
        </OverlayTrigger>
      ),
      key: "specs",
      width: 250,
      render: (_, record) => {
        const specsSummaryTitle = `Model: ${record.model || "-"}\nManufacturer: ${
          record.manufacturer || "-"
        }`;

        return (
          <div style={{ lineHeight: "1.3" }} title={specsSummaryTitle}>
            <div
              style={{
                ...primaryTextStyle,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {record.model || "-"}
            </div>
            <div
              style={{
                ...mutedTextStyle,
                marginTop: "2px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {record.manufacturer || "-"}
            </div>
          </div>
        );
      },
    },
    {
      title: (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id="tooltip-purchase-header">
              P = Purchase Price, C = Current Price, Date = Purchase Date, W = Warranty
            </Tooltip>
          }
        >
          <span>Purchase</span>
        </OverlayTrigger>
      ),
      key: "purchase_summary",
      width: 290,
      render: (_, record) => {
        const purchaseSummaryTitle = `Purchase Price: ${formatPrice(
          record.original_price
        )}\nCurrent Price: ${formatPrice(record.current_price)}\nPurchase Date: ${formatDate(
          record.purchase_date
        )}\nWarranty: ${formatWarranty(record.warranty)}`;

        return (
          <div style={{ lineHeight: "1.3" }} title={purchaseSummaryTitle}>
            <div style={primaryTextStyle}>
              P: {formatPrice(record.original_price)} | C: {formatPrice(record.current_price)}
            </div>
            <div style={{ ...mutedTextStyle, marginTop: "2px" }}>
              Date: {formatDate(record.purchase_date)} | W: {formatWarranty(record.warranty)}
            </div>
          </div>
        );
      },
    },
    {
      title: "Assigned To",
      key: "assignee_details",
      width: 260,
      render: (_, record) => {
        const assigneeName = record.assignee_name || "-";
        const assigneeEmail = record.assignee_official_email || "-";

        if (assigneeName === "-" && assigneeEmail === "-") {
          return "-";
        }

        const assigneeText = `${assigneeName} (${assigneeEmail})`;
        return (
          <div
            title={assigneeText}
            style={{
              maxWidth: "220px",
              lineHeight: "1.25",
            }}
          >
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontWeight: 600,
                color: "#111827",
                fontSize: "13px",
              }}
            >
              {assigneeName}
            </div>
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                color: "#6c757d",
                fontSize: "11px",
              }}
            >
              {assigneeEmail}
            </div>
          </div>
        );
      },
    },
    {
      title: "Available",
      key: "available",
      width: 100,
      align: "center",
      render: (_, record) => {
        const isAvailable = Boolean(record.avaiable ?? record.available);
        return (
          <span
            style={{
              ...badgeBaseStyle,
              backgroundColor: isAvailable ? "#eafaf1" : "#fdecec",
              color: isAvailable ? "#1f9254" : "#b42318",
              border: `1px solid ${isAvailable ? "#c7f0d8" : "#f8caca"}`,
            }}
          >
            {isAvailable ? "Available" : "Assigned"}
          </span>
        );
      },
    },
    {
      title: "Action",
      width: 80,
      align: "center",
      render: (text, record) => (
        <div className="d-flex gap-1 justify-content-center">
          <Link
            className="dropdown-item"
            style={{ padding: 0 }}
            onClick={(e) => {
              e.preventDefault();
              editAssetDetail(record);
            }}
          >
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip
                  id="tooltip-edit"
                  style={{ fontSize: "12px", padding: "2px" }}
                >
                  Edit Asset Detail
                </Tooltip>
              }
            >
              <i className="fa fa-pencil m-r-5 text-success" />
            </OverlayTrigger>
          </Link>
          <Link
            className="dropdown-item"
            style={{ padding: 0 }}
            onClick={(e) => {
              e.preventDefault();
              handleDeleteClick(record.id);
            }}
          >
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip
                  id="tooltip-delete"
                  style={{ fontSize: "12px", padding: "2px" }}
                >
                  Delete Asset
                </Tooltip>
              }
            >
              <i className="fa fa-trash m-r-5 text-danger" />
            </OverlayTrigger>
          </Link>
        </div>
      ),
    },
  ];
  return (
    <div>
      <div className="row">
        <div className="col-md-12">
          <div className="table-responsive">
            <div className="d-flex justify-content-between align-items-center">
              <div className="flex-grow-1">
                <SearchBox setPaginationValue={setPageSize} />
              </div>
              <div className="d-flex gap-2 ms-2 my-2">
                <select
                  className="form-select"
                  value={selectedAssetTypeFilter}
                  onChange={handleAssetTypeFilterChange}
                  style={{ width: "200px" }}
                >
                  <option value="">All Asset Types</option>
                  {assetType.map((type) => (
                    <option key={type.id} value={type.id}>
                      {type.name}
                    </option>
                  ))}
                </select>
                <button
                  className="btn text-white"
                  style={{ backgroundColor: "var(--company-theme)" }}
                  onClick={exportToExcel}
                  disabled={filteredAssets.length === 0}
                >
                  <i className="fa fa-file-excel-o me-1" />
                  Export to Excel
                </button>
              </div>
            </div>
            <Table
              className="table-striped"
              columns={columns}
              dataSource={pagedAssets}
              rowKey={(record) => record.id}
              loading={loading}
              size="small"
              scroll={{ x: true }}
              pagination={false}
            />
          </div>
        </div>
      </div>
      {filteredAssets.length > 0 && (
        <div className="d-flex justify-content-end mt-3">
          <nav aria-label="Company assets pagination">
            <ul className="pagination mb-0 align-items-center" style={{ gap: "8px" }}>
              <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                <button
                  type="button"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1, pageSize)}
                  disabled={currentPage === 1}
                  aria-label="Previous page"
                  style={{
                    ...paginationButtonStyle,
                    ...(currentPage === 1 ? paginationDisabledStyle : {}),
                  }}
                >
                  {"<"}
                </button>
              </li>

              {getVisiblePages().map((pageNumber) => (
                <li
                  key={pageNumber}
                  className={`page-item ${currentPage === pageNumber ? "active" : ""}`}
                >
                  <button
                    type="button"
                    className="page-link"
                    onClick={() => handlePageChange(pageNumber, pageSize)}
                    aria-label={`Page ${pageNumber}`}
                    style={currentPage === pageNumber ? paginationActiveStyle : paginationButtonStyle}
                  >
                    {pageNumber}
                  </button>
                </li>
              ))}

              <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                <button
                  type="button"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1, pageSize)}
                  disabled={currentPage === totalPages}
                  aria-label="Next page"
                  style={{
                    ...paginationButtonStyle,
                    ...(currentPage === totalPages ? paginationDisabledStyle : {}),
                  }}
                >
                  {">"}
                </button>
              </li>
            </ul>
          </nav>
        </div>
      )}
      <DeleteModal
        Name="Delete Asset"
        confirmDelete={deleteAsset}
        btnName={loading ? "Deleting..." : "Delete"}
        show={showModal}
        onClose={handleCloseModal}
      />
    </div>
  );
};

export default AssetDetails;
